// extracted by mini-css-extract-plugin
module.exports = {"bp-tablet-small-viewport":"(min-width: 768px)","nav":"reference-sticky-navigation_nav___VJbp","container":"reference-sticky-navigation_container__jPwvM"};